import script from "./JobTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./JobTemplate.vue?vue&type=style&index=0&id=72e0ffd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e0ffd6"]])

export default __exports__